<template>
    <div id="app">
        <router-view v-if="isShow"></router-view>
    </div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {
            // 控制router-view的隐藏与展示
            isShow: true
        }
    },
    
    mounted() {
        this.isMobile();
    },
    
    //点浏览器刷新时跳到主页
    beforeCreate() {
        if ((this.$route.path !== '/home') && (this.$route.path !== '/login') && (this.$route.path) !== '/register') {
            this.$router.push({ path: '/home' });
        }
    },
    
    // 提供可注入子组件属性
    provide() {
        return {
            reload: this.reload
        }
    },
    
    // 定义reload方法
    methods: {
        reload() {
            this.isShow = false
            // $nextTick() 将回调延迟到下次 DOM 更新循环之后执行
            this.$nextTick(() => {
                this.isShow = true
            })
        },
        
        isMobile() {
            let flag = navigator.userAgent.match(
                /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
            if (flag) {
                window.location.href = 'http://122.112.248.78:7071/';
            }
        }
    }
}

</script>



// WEBPACK FOOTER //
// src/app.vue